import React from 'react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import SidebarNavigation from './SidebarNavigation';
import UpgradeCard from './UpgradeCard';

const MobileNavigation: React.FC = () => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="outline" size="icon" className="shrink-0 md:hidden">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle navigation menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="flex flex-col">
        <SidebarNavigation showSidebar={true} />
        <div className="mt-auto">
          <UpgradeCard />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileNavigation;
